module.exports = __webpack_public_path__ + "img/regis-two.73851b37.png";